// extracted by mini-css-extract-plugin
export default {"icon-size":"24","container":"resume_container__RdbSR","content":"resume_content__2-BrL"};